<template>
  <input :type="type" class="form-control" v-model="model" :name="field" :placeholder="placeholder" :readonly="readonly" :disabled="disabled" />
</template>

<script>
  import lodash from 'lodash';

  export default {
    name: 'StoreConnectedInput',
    props: {
      store: {
        type: String,
        required: true,
      },
      action: {
        type: String,
        default: 'setProperty',
      },
      name: {
        type: String,
        required: true,
      },
      subProp: {
        default: null,
      },
      field: {
        type: String,
      },
      type: {
        type: String,
        default: 'text',
      },
      placeholder: {
        type: String,
        default: '',
      },
      readonly: {
        type: Boolean,
        default: false,
      },
      debounce: {
        type: Boolean,
        default: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      deleteOnDisabled: {
        type: Boolean,
        default: true,
      },
      callback: {
        default: null,
      },
    },
    data() {
      return {
        model: null,
        init: false,
      };
    },
    mounted() {
      this.model = this.storeValue;
      this.init = true;
    },
    watch: {
      model() {
        if (this.init) {
          this.debounce ? this.update() : this.updateStore();
          if (this.callback) {
            this.$store.dispatch(this.callback, this.model);
          }
        }
      },
      storeValue() {
        if (this.init) {
          this.model = this.storeValue;
        }
      },
      disabled() {
        if (this.disabled === true && this.deleteOnDisabled) {
          this.model = null;
        }
      }
    },
    computed: {
      modelName() {
        return this.subProp || this.name;
      },
      storeValue() {
        if (this.subProp) {
          return this.$store.getters[`${this.store}/${this.name}`][this.subProp];
        } else {
          return this.$store.getters[`${this.store}/${this.name}`];
        }
      },
    },
    methods: {
      update: lodash.debounce(function () {
        setTimeout(function () {
          this.updateStore();
        }.bind(this), 500);
      }, 500),
      updateStore() {
        if (this.subProp) {
          this.$store.dispatch(`${this.store}/${this.action}`, {
            object: this.name,
            key: this.modelName,
            value: this.model
          });
        } else {
          this.$store.dispatch(`${this.store}/${this.action}`, {
            key: this.modelName,
            value: this.model
          });
        }
      },
    },
  };
</script>
